import { defineMessages, IntlShape } from 'react-intl'
import * as yup from 'yup'

import { INewOperationalCostsFormValues } from 'features/OperationalCosts/types'

const messages = defineMessages({
  required: {
    id: 'newOperationalCosts.form.required',
    defaultMessage: 'Required'
  }
})

const vehicleCapacityMessages = defineMessages({
  min: {
    id: 'newOperationalCosts.form.vehicleCapacity.min',
    defaultMessage: 'Minimum value is {min}'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<INewOperationalCostsFormValues> => {
  return yup.object().shape({
    businessClient: yup
      .object()
      .shape({
        id: yup.string().required(intl.formatMessage(messages.required)),
        name: yup.string().required(intl.formatMessage(messages.required))
      })
      .nullable(),
    businessSite: yup
      .object()
      .shape({
        id: yup.string().required(intl.formatMessage(messages.required)),
        name: yup.string().required(intl.formatMessage(messages.required))
      })
      .nullable(),
    stateCode: yup.string().required(intl.formatMessage(messages.required)),
    vehicleType: yup.mixed().nullable().required(intl.formatMessage(messages.required)),
    vehicleCapacity: yup
      .number()
      .nullable()
      .min(1, ({ min }) => intl.formatMessage(vehicleCapacityMessages.min, { min }))
      .required(intl.formatMessage(messages.required)),
    airConditioning: yup.number().nullable().required(intl.formatMessage(messages.required)),
    baseDistance: yup.number().nullable().required(intl.formatMessage(messages.required)),
    perKm: yup.number().nullable().required(intl.formatMessage(messages.required)),
    redZone: yup.number().nullable().required(intl.formatMessage(messages.required)),
    durationSettings: yup.array().of(
      yup.object().shape({
        range: yup.object().shape({
          start: yup.number().nullable().required(intl.formatMessage(messages.required)),
          end: yup.number().nullable().required(intl.formatMessage(messages.required))
        }),
        factor: yup.number().nullable().required(intl.formatMessage(messages.required))
      })
    ),
    durationCost: yup.number().nullable().required(intl.formatMessage(messages.required)),
    costPerKm: yup.number().nullable().required(intl.formatMessage(messages.required)),
    costPerDriver: yup.number().nullable().required(intl.formatMessage(messages.required)),
    fixedCost: yup.number().nullable().required(intl.formatMessage(messages.required))
  })
}
